import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client';
import './index.css';
import './responsive.css';
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';

import Acknowledgement from './pages/Acknowledgement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import NavBar from './components/NavBar';
import Preloader from './components/Preloader';
import ScrollToTop from './components/ScrollToTop';



const Dams = lazy(() => import('./pages/Dams'));
const StateWise = lazy(() => import('./pages/StateWise'));
const BasinWise = lazy(() => import('./pages/BasinWise'));
const DamRiskAnalysis = lazy(() => import('./pages/DamRiskAnalysis'));
const ProjectedRisk = lazy(() => import('./pages/ProjectedRisk'));




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <NavBar/>
    {/* <Preloader /> */}
    <Suspense fallback={<Preloader />}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<Contact/>} />

      <Route path="/dams" element={<Dams/>} />
      <Route path="/dams/state-wise" element={<StateWise/>} />
      <Route path="/dams/basin-wise" element={<BasinWise/>} />
      
      <Route path="/projected-risk" element={<ProjectedRisk/>} />
      <Route path="/privacy-policy" element={<PrivacyPolicy/>} />

      <Route path="/acknowledgement" element={<Acknowledgement/>} />
      <Route path="/terms-of-use" element={<TermsOfUse/>} />
      
      <Route path="/projected-risk/dam-risk-analysis" element={<DamRiskAnalysis/>} />
    </Routes>
    </Suspense>
    <Footer />
    <ScrollToTop/>
  </Router>,


  


);

